<script setup>
import {onMounted} from "vue";

onMounted(() => {
  setTimeout(() => {
    window.location.href = "https://www.cc-sms.fr/mobilite/";
  }, 10000);

});

</script>
